// extracted by mini-css-extract-plugin
export default {"container":"styles_container__h5fK6","title":"styles_title__BVqZE","actions":"styles_actions__0zWts"};